import type { Post } from '@/entities/post/types';
import { socialApiClient } from '@/shared/api-client/social-api-client';

export const fetchPost = async (workspaceId: string, postId: string, signal?: AbortSignal) => {
  const response = await socialApiClient.get(`workspaces/${workspaceId}/posts/${postId}`, {
    signal,
  });
  return response.json<Post>();
};
